import type { ApiCommand, ApiRequest } from './apiCommand';
import type { FieldValue } from '../dto/fieldValue';

interface GetEXIFEmbeddedImageURLInput {
  url: string;
  fileName: string;
  mdf: {
    formId: string;
    formData: Record<string, FieldValue>;
  };
  itemId: string;
}

interface GetEXIFEmbeddedImageURLOutput {
  message: string;
  downloadUrl: string;
  hasExifError?: boolean;
}

export class GetEXIFEmbeddedImageURLCommand implements ApiCommand<GetEXIFEmbeddedImageURLOutput> {
  constructor(private input: GetEXIFEmbeddedImageURLInput) { }

  request(): ApiRequest {
    return {
      linkName: 'getEXIFEmbeddedImageURL',
      pathParams: {},
      queryParams: {},
      method: 'POST',
      body: JSON.stringify(this.input),
    };
  }

  asOutput(body: unknown): GetEXIFEmbeddedImageURLOutput {
    return body as GetEXIFEmbeddedImageURLOutput;
  }
}
